<template>
  <div class="page-list">
    <div class="border-bottom">
      <div class="title">查看开票申请</div>
      <button
        type="button"
        class="btn btn-secondary float-right"
        @click="$router.push('/buyer/apply')"
      >返回列表</button>
    </div>
    <br />
    <div class="row">
      <div style="width:100px;">选择发票抬头</div>
      <div class="col-lg-5">{{ detail.title }}</div>
      <div style="width:100px;">已开发票编号</div>
      <div class="col-lg-3">{{ detail.number }}</div>
    </div>
    <div class="row">
      <div style="width:100px;">选择发票类型</div>
      <div class="col-lg-5">{{ detail.kind?detail.kindLiteral:'' }}</div>
      <div style="width:100px;">开票日期</div>
      <div class="col-lg-3">{{ detail.invoiceDate | toShortDate }}</div>
    </div>
    <div class="row">
      <div style="width:100px;">发票内容</div>
      <div class="col-lg-5">{{ detail.requireContent?detail.requireContentLiteral:'' }}</div>
      <div style="width:100px;">开票金额(元)</div>
      <div class="col-lg-3">{{ detail.amount | toMoney }}</div>
    </div>
    <div class="row">
      <div style="width:100px;">开票金额</div>
      <div class="col-lg-5">{{ detail.amount | toMoney }}</div>
      <div style="width:100px;">开票人</div>
      <div class="col-lg-3">{{ detail.issuerName }}</div>
    </div>
    <div style="display:flex;">
      <div style="flex:1;">
        <div class="row">
          <div style="width:100px;">纳税识别号</div>
          <div class="col-lg-5">{{ detail.taxNumber }}</div>
        </div>
        <div class="row">
          <div style="width:100px;">开户银行</div>
          <div class="col-lg-5">{{ detail.bankName }}</div>
        </div>
        <div class="row">
          <div style="width:100px;">银行账号</div>
          <div class="col-lg-5">{{ detail.bankAccount }}</div>
        </div>
      </div>
      <div style="flex:1;">
        <div class="row">
          <div style="width:110px;">&nbsp;&nbsp;发票附件</div>
          <div class="col-lg-8">
            <div class="evidence-item" v-for="it in detail.attachments" :key="it.uri">
              <a class="link" download :href="getOpenFileUrl(it.uri)">
                <span style="font-size:16px;" class="fas fa-file-download"></span>
              </a>
              <a class="link" target="_blank" :href="getOpenFileUrl(it.uri)">{{ it.name }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <br />
      <strong>发票对应的项目</strong>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>订单号</th>
          <th>物流单号</th>
          <th>开票金额</th>
          <th>收货确认时间</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in detail.relations" :key="item.id">
          <td>{{ item.salesOrderNumber }}</td>
          <td>{{ item.logisticsNumber }}</td>
          <td>{{ item.invoicedAmount | toMoney }}</td>
          <td>{{ item.occurDate | toShortDate }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return { id: "", detail: {} };
  },
  created() {
    let id = this.$route.params.id;
    if (id) {
      this.id = id;
      this.getData();
    }
  },
  methods: {
    getData() {
      this.$get(
        "/pass/salesInvoice/get/" + this.id,
        {},
        {
          success(res) {
            this.detail = res;
          }
        }
      );
    },
  }
};
</script>

<style lang="less" scoped>
@import url("~@assets/less/vars.less");

.page-list {
  .border-bottom {
    overflow: hidden;
    .title {
      margin-bottom: 20px;
      font-size: 24px;
      line-height: 36px;
      float: left;
    }
    .btn {
      margin: 1px 1px 0 15px;
    }
  }
  .row {
    padding: 5px 15px;
    font-size: 12px;
  }
  .evidence-item {
    padding: 5px 0;
    .link {
      color: #333;
      margin-right: 10px;
      &:hover {
        text-decoration: underline;
        color: rgb(0, 153, 204);
      }
    }
  }
  table {
    thead {
      display: table;
      width: 100%;
      table-layout: fixed;
      width: calc(100% - 17px);
    }
    tbody {
      display: block;
      height: 450px;
      overflow-y: scroll;
    }
    tr {
      display: table;
      width: 100%;
      table-layout: fixed;
    }
    td {
      vertical-align: middle;
    }
  }
}
</style>